export default __webpack_public_path__ + "static/media/finder_grid_disable.88f4960c.svg";